import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetArrowDown: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 4v16m0 0l6-6m-6 6l-6-6" />
      </svg>
    </div>
  );
};

export default WidgetArrowDown;
